import { render, staticRenderFns } from "./filterTags.vue?vue&type=template&id=52f0e7ae&scoped=true&"
import script from "./filterTags.vue?vue&type=script&lang=js&"
export * from "./filterTags.vue?vue&type=script&lang=js&"
import style0 from "./filterTags.vue?vue&type=style&index=0&id=52f0e7ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0e7ae",
  null
  
)

export default component.exports